import React, { createElement, useRef } from 'react'
import { Circle, HStack, Icon, useDisclosure, LinkBox, LinkOverlay, IconButton, forwardRef, Popover, PopoverTrigger, PopoverContent, PopoverArrow, PopoverBody } from "@chakra-ui/react"
import { IoVolumeMedium, IoVolumeOff } from "react-icons/io5";

import Box from '../components/Box';
import Flex from '../components/Flex';
import Link from '../components/Link';
import BackgroundImage from '../components/BackgroundImage';
import { Media, responsive } from '../contexts/responsive';

import Menu from './Menu';

// import logo from './logo.png';
import logo from './logo.svg';
import logo_black from './logo_black.svg';
import logo_text from './logo_text.svg';
import logo_text_black from './logo_text_black.svg';
import IconMenu from './HomePage/IconMenu';
import useHeader from '../contexts/header/useHeader';

const HeaderIconButton = forwardRef((props, ref) => (
  <IconButton
    colorScheme="whiteAlpha"
    borderRadius="full"
    color="inherit"
    variant="outline"
    w={responsive(9, null, '2.5em', '3em', '3.5em')}
    h={responsive(9, null, '2.5em', '3em', '3.5em')}
    minW="auto"
    ref={ref}
    {...props}
  />
))

const Header = ({ siteTitle, color, pos, isSubheader, ...props }) => {
  const { isPlaying, setPlaying, notifiedSound, setNotified } = useHeader()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const soundButton = (
    <HeaderIconButton
      onClick={() => setPlaying(!isPlaying)}
      icon={createElement(isPlaying ? IoVolumeMedium : IoVolumeOff, { size: '75%' })}
    />
  )
  const popoverRef = useRef()
  return (
    <Flex
      as="header"
      position={pos || 'fixed'}
      px={responsive('1em', '3.375em')}
      pt={responsive('0.5em', '1em')}
      top={0}
      left={0}
      right={0}
      alignItems="center"
      justifyContent="space-between"
      zIndex="docked"
      color={color}
      transition="color 0.2s ease-in-out"
      {...props}
    >
      <LinkBox
        as={Flex}
        cursor={'pointer'}
        width={responsive('32%', '35%')}
        alignItems="center"
      >
        <BackgroundImage width={responsive('100%', '37%')} src={color === 'black' ? logo_black : logo} ratio={202 / 45} />
        <Box flex={1} as={Media} greaterThanOrEqual='md'>
          <BackgroundImage src={color === 'black' ? logo_text_black : logo_text} ratio={344 / 45} />
        </Box>
        <LinkOverlay as={Link} to="/#" />
      </LinkBox>
      <HStack spacing="0.5em">
        {isSubheader ? soundButton : (
          <div>
            <Popover
              isOpen={!notifiedSound}
              onClose={() => {
                if (document.getElementById('initial-loading')) {
                  popoverRef.current.focus()
                  return
                }
                setNotified(true)
              }}
            >
              <PopoverTrigger>
                {soundButton}
              </PopoverTrigger>
              <PopoverContent ref={popoverRef}>
                <PopoverArrow />
                <PopoverBody color="gray.800" fontSize={responsive('20px', '22px')}>
                  建議開啟聲音，獲得更完整的海底體驗喔！
                </PopoverBody>
              </PopoverContent>
            </Popover>
          </div>
        )}
        <HeaderIconButton icon={<IconMenu w="58%" />} onClick={onOpen} />
        {/* <Circle cursor={'pointer'} border={'1px solid'} p={responsive('0.25em', '0.625em')}>
          <BackgroundAudio isPlaying={isPlaying} w={responsive(7, '2.5em')} h={responsive(7, '2.5em')} />
        </Circle>
        <Circle cursor={'pointer'} border={'1px solid'} p={responsive('0.375em', '0.875em')} onClick={onOpen}>
          <Icon as={IconMenu} w={responsive(6, '2em')} h={responsive(6, '2em')} />
        </Circle> */}
      </HStack>
      <Menu isOpen={isOpen} onClose={onClose} />
    </Flex>
  )
}

export default Header
